import { NgModule } from '@angular/core';
import { AbstractSecurityStorage, AuthModule, LogLevel } from 'angular-auth-oidc-client';

import {environment} from '@env/environment';
import {
    COOKIE_SCHOOL_PASSPORT_LOGIN_DOMAIN_KEY_NAME,
    SessionCookieStorage
} from '@app/core/security/session-cookie-storage';
import {CookieStorage} from "@app/core/security/cookie-storage";
import {SCHOOL_PASSPORT_AUTH_COOKIE_NAME} from "@app/core/model/user";

const moduleImports = [];
if (environment.stsServer) {
    const cookieStorage = new CookieStorage();
    const isUserAuthorizedViaSchoolPassport = !!cookieStorage.read(SCHOOL_PASSPORT_AUTH_COOKIE_NAME);
    const schoolPassportLoginDomain = cookieStorage.read(COOKIE_SCHOOL_PASSPORT_LOGIN_DOMAIN_KEY_NAME);
    let issValidationOff = false;
    const defaultStsServer = environment.stsServer;
    if (isUserAuthorizedViaSchoolPassport && schoolPassportLoginDomain) {
        const etxBaseURI = `https://${schoolPassportLoginDomain}`;
        issValidationOff = (etxBaseURI !== environment.etxBaseURI);
        environment.etxBaseURI = etxBaseURI;
        environment.stsServer = `${environment.etxBaseURI}/account`;
    }

    moduleImports.push(AuthModule.forRoot({
        config: {
            configId: environment.spOidcClientId,
            authority: environment.stsServer,
            redirectUrl: `${window.location.origin}/auth/oauth`,
            postLogoutRedirectUri: window.location.origin,
            clientId: environment.spOidcClientId,
            scope: 'openid profile offline_access',
            responseType: 'code',
            startCheckSession: true,
            silentRenew: true,
            useRefreshToken: true,
            logLevel: environment.production ? LogLevel.None : LogLevel.Debug,
            ignoreNonceAfterRefresh: true,
            renewTimeBeforeTokenExpiresInSeconds: 60,
            triggerRefreshWhenIdTokenExpired: false,
            authWellknownEndpoints: {
                issuer: defaultStsServer,
                jwksUri: `${environment.stsServer}/jwks`,
                authorizationEndpoint: `${environment.stsServer}/default/authorize`,
                tokenEndpoint: `${environment.stsServer}/token`,
                userInfoEndpoint: `${environment.stsServer}/userinfo`,
                revocationEndpoint: `${environment.stsServer}/revoke`,
                introspectionEndpoint: `${environment.stsServer}/introspect`,
            }
        }
    }));
} else {
    moduleImports.push(AuthModule.forRoot({}));
}

@NgModule({
    imports: moduleImports,
    exports: [AuthModule],
    providers: [
        {
            provide: AbstractSecurityStorage,
            useClass: SessionCookieStorage,
        },
    ],
})
export class AuthConfigModule {
}
